<template>
  <div>
    <div class="application-block">
      <p class="title"><i class="fal fa-file-alt"></i> 약관 동의
        <label class="No Fs16 lib-ml-20">
          <input type="checkbox" id="agreement" class="lib-mr-5" @change="checkAllAgreement($event)">전체 동의</label>
      </p>
      <ul class="list-clause-pay">
        <li v-for="clauseCompositionInfo in clauseCompositionList" :key="clauseCompositionInfo.id">
          <div v-if="clauseCompositionInfo.display_info">
            <label>
              <input type="checkbox"
                     :value="clauseCompositionInfo.id"
                     v-model="checkedClauseCompositionList"
                     class="lib-mr-5"> {{clauseCompositionInfo.clause.sentence}}
            </label>
            <a :href="getClauseLink(clauseCompositionInfo.display_info.data)"
               target="_blank"
               class="hw-pill-button bordered smaller float-right"> 내용 보기 </a>
          </div>
          <div v-else>
            <label>
              <input type="checkbox"
                     :value="clauseCompositionInfo.id"
                     v-model="checkedClauseCompositionList"
                     class="lib-mr-5"> {{clauseCompositionInfo.clause.sentence}}
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import sitesInfo from "@/js/helper/sites-info"

export default {
  name: "Agreement",
  data(){
    return {
      isAllCheck : false,
    }
  },
  computed : {
    ...mapState({
      clauseCompositionList: state => state['goods_info']['package_info']['clause_composition'],
    }),
    checkedClauseCompositionList:{
      get () {return this.$store.state.order_info.checkedClauseCompositionList},
      set (idList) {this.$store.commit("order_info/setCheckedClauseCompositionList", idList);
      }
    }
  },
  methods:{
    getClauseLink(type){
      return sitesInfo.wwwHiworks + '/agreement/' + type
    },
    checkAllAgreement(event){
      let idList = []
      if(event.target.checked){
        idList = this.clauseCompositionList.map(clauseCompositionInfo => clauseCompositionInfo.id)
      }
      this.$store.commit("order_info/setCheckedClauseCompositionList", idList);
    }
  }
}
</script>

<style scoped>

</style>